import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";
import { Datetime } from "./datetime";

@Component({
    selector: "datetime-editor",
    templateUrl: "./datetime-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatetimeEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            placeholder: [this.datetime.placeholder],
            layout: [this.datetime.layout],
        });
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get datetime() {
        return this.field as Datetime;
    }
}
